import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ReactGA from 'react-ga';
import { IdleTimer, withTracker } from '@components';
import reportWebVitals from '../reportWebVitals';
import { Review } from '../pages';
import '../index.css';

const { REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID, REACT_APP_PATH_REVIEW } = process.env;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function App() {
  ReactGA.initialize(`${REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID}`);
  const TrackedReview = withTracker(Review);
  return (
    <Router>
      <div className="App">
        <IdleTimer />
        <Routes>
          <Route path={`${REACT_APP_PATH_REVIEW}/*`} element={<TrackedReview />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

const root = createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
